import { render, staticRenderFns } from "./EditDeleteOrderConfirmation.vue?vue&type=template&id=0637e59a"
import script from "./EditDeleteOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./EditDeleteOrderConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports